import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresExportarComponent {
  constructor($state, FanProyectoReportesColaboradoresService) {
    this.$state = $state
    this.FanProyectoReportesColaboradoresService = FanProyectoReportesColaboradoresService
    this.file = null
    this.procesando = false
    this.config = {
      activo: 1,
      documentos: false,
      fecha_alta_ini: null,
      fecha_alta_fin: null,
      fecha_baja_ini: null,
      fecha_baja_fin: null,
      ultima_nomina: false,
    }
    this.catalogos = {
      estatus: [
        {id: null, descripcion: 'Todos'},
        {id: 1, descripcion: 'Activos'},
        {id: 0, descripcion: 'Inactivos'},
      ],
    }
    this.idProyecto = undefined
    this.onClose = undefined
  }

  actualizarEstatus() {
    if (this.config.activo !== 1) {
      this.config.fecha_alta_ini = this.config.fecha_alta_fin = null
    }

    if (this.config.activo !== 0) {
      this.config.fecha_baja_ini = this.config.fecha_baja_fin = null
    }
  }

  generar() {
    this.procesando = true

    return this.FanProyectoReportesColaboradoresService.get(this.idProyecto, this.config)
      .then((response) => {
        this.file = response.data

        this.guardar()
      })
      .finally(() => (this.procesando = false))
  }

  cerrar() {
    this.$state.go('^.lista')
  }

  guardar() {
    if (!this.file) return

    this.file.save()
  }
}

module.component('fanProyectoColaboradoresExportar', {
  controller: FanProyectoColaboradoresExportarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/exportar/component.js